import { Media } from "components";

import { DriverCertificateBlockProps } from "./DriverCertificateBlock.types";

import styles from "./DriverCertificateBlock.module.scss";

const DriverCertificateBlock = ({
  header,
  images,
  onImageClick
}: DriverCertificateBlockProps) => {
  return (
    <div className={styles.certificatesBlock}>
      <div className={styles.certificatesBlock_header}>
        {header.map((element) => (
          <div
            className={styles.certificatesBlock_headerBlock}
            key={`${element.title}`}
          >
            <h3 className={styles.certificatesBlock_headerBlock_title}>
              {element.title}
            </h3>
            <span className={styles.certificatesBlock_headerBlock_subtitle}>
              {element.subtitle}
            </span>
          </div>
        ))}
      </div>
      <div className={styles.certificatesBlock_gallery}>
        {images?.map((image, index) => (
          <div
            key={`${image.key}-${index}`}
            onClick={() => onImageClick?.(image)}
          >
            <Media
              className={styles.certificatesBlock_galleryImage}
              mediaFile={image}
              onClick={() => onImageClick?.(image)}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default DriverCertificateBlock;
